<template>
   <div>
      <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />

      <div class="auth-wrapper auth-v2">
         <div class="row auth-inner m-0">
            <div class="d-none d-lg-flex align-items-center p-5 col-lg-7" style="background-color: #f8f8f8">
               <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                  <img src="/images/email-verify.png" alt="email-verify" class="img-fluid">
               </div>
            </div>
            <div class="d-flex align-items-center auth-bg px-2 p-lg-5 col-lg-5">
               <div class="px-xl-2 col-sm-8 col-md-6 col-lg-12">
                  <center><img src="/images/sbc-logo.png" alt="SBC logo" class="img-fluid mt-3 mt-md-0" style="height:75px;"></center>
                  <p class="font-weight-bold mb-1 fs-24 pt-5">Verify your email address</p>

                  <div class="fs-17">
                     <p>An email from SB Corp. has been sent to the email address listed below:</p>
                     <p><b>{{user.email}}</b></p>

                     <p class="text-justify">Kindly check your <b>INBOX, JUNK or SPAM</b> mail folders for the
                        said email. Click the <b>"Verify Email"</b> link button in the said email to proceed
                        with your registration for your loan application.
                     </p>
                     <p class="text-justify">If you did not received the email from SB Corp, kindly click the button below:</p>
                     <div class="text-center mb-4 mt-4">
                        <button class="btn btn-primary px-4" @click="resendVerification()">Resend email verification</button>
                     </div>
                     <p class="text-justify">Further, If you did not receive any email verification from the registered email address within 5-10 minutes after creating an account, <a href="javascript:void(0)" data-toggle="modal" data-target="#updateEmail"><u>click here to update your email address.</u></a></p>
                  </div>

                  <div class="text-center mt-5">
                     <button class="btn btn-outline-primary px-5" @click="backLogin"><i class="fas fa-arrow-left mr-3"></i>Back to Login</button>
                  </div>
               </div>
            </div>
         </div>
      </div>


      <div class="modal fade" id="updateEmail" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
         <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Update Email</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">

                  <div class="alert alert-danger2 alert-dismissible" role="alert" v-if="error">
                     <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=false">&times;</button>
                     <a target="#err0" hidden id="err"></a>
                     <div class="alert-body">
                        <p v-if="error_message && errors.length == 0" class="mb-0">
                           {{ error_message }}
                        </p>
                        <div v-for="(v, k) in errors" :key="k">
                           <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                        </div>
                     </div>
                  </div>

                  <div class="form-group">
                     <label>Registered email address</label>
                     <input class="form-control" :value="user.email" disabled>
                  </div>

                  <div class="form-group">
                     <label>New email address</label>
                     <input class="form-control text-lowercase" v-model="email" :class="{ 'is-invalid': $v.email.$error }" @input="preventSpace">
                     <span class="fs-12 text-danger" v-if="$v.email.$error && email">Please enter a valid email address</span>
                     <span class="fs-12 text-danger" v-if="$v.email.$error && !email">This field is required</span>
                  </div>

               </div>
               <div class="modal-footer">
                  <button class="btn btn-outline-primary px-3 mr-auto" data-dismiss="modal">
                     Cancel
                  </button>
                  <button class="btn btn-primary px-3" @click="btnUpdate()">
                     Submit
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import {
      required,
      email,
   } from "vuelidate/lib/validators";
   export default {
      props: {
         user: {
            type: [Array, Object],
            required: true
         }
      },
      data() {
         return {
            email: '',
            error: false,
            errors: [],
            error_message: '',
            loader: 0,
         };
      },
      computed: {
         processingAPI() {
            return this.loader > 0;
         },
      },
      validations: {
         email: {
            required,
            email
         },
      },
      methods: {
         preventSpace(){
            this.email = this.email.replace(/\s+/g, '');
         },
         backLogin() {
            axios
               .post("/logout")
               .then((res) => {
                  location.href = '/login';
               })
         },
         resendVerification() {
            this.loader++;
            axios
               .post("/email/resend")
               .then((res) => {
                  this.loader--;
                  Swal.fire({
                     icon: 'success',
                     title: 'Success',
                     text: 'A new verification link has been sent to your email address',
                     allowOutsideClick: false,
                     allowEscapeKey: false,
                     allowOutsideClick: false,
                  });
               })
               .catch((err) => {
                  this.loader--;
               });
         },
         btnUpdate() {
            this.$v.email.$touch();
            if (this.$v.email.$invalid) {
               return;
            } else {
               this.apiUpdateEmail()
            }
         },
         apiUpdateEmail() {
            this.loader++;
            axios
               .post("/email-update", {
                  id: this.user.id,
                  email: this.email
               })
               .then((res) => {
                  this.loader--;
                  axios.post("/logout");
                  $("#updateEmail").modal("hide");
                  Swal.fire({
                     icon: 'success',
                     title: 'Success',
                     text: 'Your email address has been updated. Kindly log in again using the new email address.',
                     allowOutsideClick: false,
                     allowEscapeKey: false,
                     allowOutsideClick: false,
                  }).then((result) => {
                     location.href = '/login';
                  });
               })
               .catch((err) => {
                  this.loader--;
                  this.error = 1;
                  if (err.response && err.response.data) {
                     this.errors = err.response.data.errors || [];
                     this.error_message = err.response.data.message;
                  } else {
                     this.error_message = 'Transaction Failed'
                  }
               });
         },
      },
      mounted() {},
   };
</script>

<style scoped>
</style>